module.exports = __webpack_public_path__ + "fonts/TTFirs-Thin.5b70e94f.eot";